import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';

const Container = styled.div`
  max-width: 40rem;
  margin: 4rem auto;
  padding: 2rem;
  background-color: white;
  border-radius: 0px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  text-align: center;
`;

const Title = styled.h1`
  font-size: 1.5rem;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 0.5rem;
`;

const Subtitle = styled.p`
  color: #4b5563;
  margin-bottom: 1.5rem;
`;

const ContinueButton = styled.button`
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 0px;
  font-size: 0.875rem;
  font-weight: 500;
  color: white;
  background-color: #47ABDB;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: #0056b3;
  }
`;

// Landing spot right after accepting a speaker invitation. The actual
// profile/bio/disclosure data model isn't built yet - this is a placeholder
// so the invite flow has somewhere real to send people in the meantime.
const SpeakerOnboarding = () => {
  const navigate = useNavigate();

  return (
    <Container>
      <Title>Welcome!</Title>
      <Subtitle>
        Thanks for confirming your invitation. Soon you'll be asked to review and
        confirm a few details about yourself here. For now, you're all set.
      </Subtitle>
      <ContinueButton onClick={() => navigate('/speaker/dashboard')}>
        Continue to Dashboard
      </ContinueButton>
    </Container>
  );
};

export default SpeakerOnboarding;
